export default __webpack_public_path__ + "images/slide-thumbnail.jpg";